<template>
  <div v-if="superAdmin">
      <v-layout wrap row justify-start  pa-4>
        <v-flex xs12 px-2>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Data
						</v-card-title>
            <v-card-text>
              <v-layout row wrap>
								<v-flex xs12 md12 pa-1>
									<v-textarea
										label="keys"
										v-model="pastedData"
										solo
									></v-textarea>
              	</v-flex>
								<v-flex xs12 class="text-xs-center">
									{{logger}}
								</v-flex>
								<v-flex xs12>
									<div v-for="k in pKeys" :key="k">{{k}}</div>
								</v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="archive()" :loading="loading" color="error" dark>
                archive keys
              </v-btn>
              <v-btn @click="crmToNinja()" :loading="loading" color="success" dark>
                CRM TO NINJA UUID
              </v-btn>
              <v-btn @click="crmToNinjaReprice()" :loading="loading" color="success" dark>
                REPRICE | CRM TO NINJA UUID 
              </v-btn>
              <v-btn @click="crmToNinjaRepriceUpdateCurrency()" :loading="loading" color="success" dark>
                REPRICE | CRM TO NINJA UUID + UPDATE CURRENCY
              </v-btn>
              <v-btn @click="crmToNinjaRepriceUpdateFees()" :loading="loading" color="success" dark>
                REPRICE | CRM TO NINJA UUID + UPDATE FEES
              </v-btn>
              
              <v-btn @click="ninjaToCrm()" :loading="loading" color="info" dark>
                NINJA TO CRM UUID
              </v-btn>
              <v-btn @click="ninjaToExternal()" :loading="loading" color="info" dark>
                NINJA TO EXTERNAL
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate} from '@/customFunction';
import countriesJSON from '@/countries-ash.json'
import axios from 'axios';
import { crmApiUrl } from '@/config/urls';
const headers = {
  'Accept': 'application/json'
}
export default {
  data(){
    return {
			loading: false,
			pastedData:null,
			delimiter:',',
			logger:null,
			pKeys:[],
			countriesFullLoaded:countriesJSON,
			taxrates:null,
			last:null,
			limit:3,
			loops:2
    }
  },
  methods: {
		guessDelimiters (text, possibleDelimiters) {
			return possibleDelimiters.filter(weedOut);
			function weedOut (delimiter) {
				var cache = -1;
				return text.split('\n').every(checkLength);
				function checkLength (line) {
					if (!line) {
							return true;
					}
					var length = line.split(delimiter).length;
					if (cache < 0) {
							cache = length;
					}
					return cache === length && length > 1;
				}
			}
		},
		getArray(){
			let csv = this.pastedData
			let dels = [' ', '  ', ',', '	', '\t']
			this.delimiter = ','
			if(this.delimiter && this.delimiter > 1) {
				this.$emit('snackbarNotification', `Please export as CSV`, 'error')
				return
			}
			var lines=csv.split("\n");
			var result = [];
			var headers=lines[0].split(this.delimiter);
			for(var i=1;i<lines.length;i++){
					if (!lines[i])
							continue
					var obj = {};
					var currentline=lines[i].split(this.delimiter);
					for(var j=0;j<headers.length;j++){
							obj[headers[j]] = currentline[j];
					}
					result.push(obj);
			}
			console.log(result);
			return result
		},
    async archive(){
      return new Promise(async (res, rej)=>{
        this.pKeys=[]
        let a = this.getArray();
        (async () =>{
          for (let i = 0; i < a.length; i++) {
            const order = a[i];
            if(order.key){
              let old = await store.collection(`leads`).doc(order.key).get().then(x=>x.data())
              await store.collection(`leads_archive`).doc(order.key).set(old)
              await axios.get(crmApiUrl(`archive-key-77885/${order.key}`)).then(x=>x.data)
              await store.collection(`leads`).doc(order.key).delete()
              this.logger = order.key
              this.pKeys.push(order.key)
              console.log(order.key)
            }
          }
          this.logger = 'DONE'
        })()
      })
    },
    async crmToNinjaReprice(){
      return new Promise(async (res, rej)=>{
        this.pKeys=[]
        let a = this.getArray();
        (async () =>{
          for (let i = 0; i < a.length; i++) {
            const order = a[i];
            if(order.uuid){
              let r = await axios.get(crmApiUrl(`sync-code-lead-ids-from-crm-reprice-2588852/${order.uuid}`)).then(x=>x.data)
              this.logger = order.uuid
              this.pKeys.push(order.uuid)
              console.log(order.uuid, r)
            }
          }
          this.logger = 'DONE'
        })()
      })
    },
    async crmToNinjaRepriceUpdateCurrency() {
      return new Promise(async (res, rej) => {
        this.pKeys = []
        let a = this.getArray();
        (async () => {
          for (let i = 0; i < a.length; i++) {
            const order = a[i];
            if (order.uuid) {
              let r = await axios.get(crmApiUrl(`sync-code-lead-ids-from-crm-reprice-currency-2588852/${order.uuid}/true`)).then(x => x.data)
              this.logger = order.uuid
              this.pKeys.push(order.uuid)
              console.log(order.uuid, r)
            }
          }
          this.logger = 'DONE'
        })()
      })
    },
    async crmToNinjaRepriceUpdateFees() {
      return new Promise(async (res, rej) => {
        this.pKeys = []
        let a = this.getArray();
        (async () => {
          for (let i = 0; i < a.length; i++) {
            const order = a[i];
            if (order.uuid) {
              let r = await axios.get(crmApiUrl(`sync-code-lead-ids-from-crm-reprice-currency-2588852/${order.uuid}/false/true`)).then(x => x.data)
              this.logger = order.uuid
              this.pKeys.push(order.uuid)
              console.log(order.uuid, r)
            }
          }
          this.logger = 'DONE'
        })()
      })
    },
    async crmToNinja(){
      return new Promise(async (res, rej)=>{
        this.pKeys=[]
        let a = this.getArray();
        (async () =>{
          for (let i = 0; i < a.length; i++) {
            const order = a[i];
            if(order.uuid){
              let r = await axios.get(crmApiUrl(`sync-code-lead-ids-from-crm-2588852/${order.uuid}`)).then(x=>x.data)
              this.logger = order.uuid
              this.pKeys.push(order.uuid)
              console.log(order.uuid, r)
            }
          }
          this.logger = 'DONE'
        })()
      })
    },
    async ninjaToExternal() {
      return new Promise(async (res, rej) => {
        this.pKeys = []
        let a = this.getArray();
        (async () => {
          for (let i = 0; i < a.length; i++) {
            const order = a[i];
            if (order.uuid) {
              let r = await axios.get(crmApiUrl(`sync-to-external-22/${order.uuid}`)).then(x => x.data)
              this.logger = order.uuid
              this.pKeys.push(order.uuid)
              console.log(order.uuid, r)
            }
          }
          this.logger = 'DONE'
        })()
      })
    },
    async ninjaToCrm(){
      return new Promise(async (res, rej)=>{
        this.pKeys=[]
        let a = this.getArray();
        (async () =>{
          for (let i = 0; i < a.length; i++) {
            const order = a[i];
            if(order.uuid){
              let r = await axios.get(crmApiUrl(`sync-lead-uuid-to-crm-2588852/${order.uuid}`)).then(x=>x.data)
              this.logger = order.uuid
              this.pKeys.push(order.uuid)
              console.log(order.uuid, r)
            }
          }
          this.logger = 'DONE'
        })()
      })
    }
  },
  props:{
		superAdmin:{
			required:true
		},
		userName:{
			default:null
		}
  },
  computed:{
    
  },
  async created(){

		
  }
}
</script>

<style>
.tokenField * {
  color:white !important;
}
</style>
